import ReactDOM from 'react-dom'
import { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Provider } from 'react-redux'
import App from 'App'
import ErrorPage from 'pages/common/Error'
import Loading from 'pages/common/Loading'
import configureStore from 'state'
import { QueryClient, QueryClientProvider } from 'react-query'
import UserContextProvider from 'context/UserContext'
import { PersistGate } from 'redux-persist/integration/react'
import 'styles/index.css'
import 'styles/common.less'
import './i18n' // Import i18n configuration
// import "antd-css-utilities/utility.min.css";

// @ts-ignore
function ErrorFallback({ error, resetErrorBoundary, ...rest }) {
  return <ErrorPage error={error} />
}

const queryClient = new QueryClient({ refetchOnWindowFocus: false })
const { store, persistor } = configureStore()

const MainApp = () => (
  <Suspense fallback={<Loading />}>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <UserContextProvider>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
              <App />
            </ErrorBoundary>
          </UserContextProvider>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </Suspense>
)

ReactDOM.render(<MainApp />, document.getElementById('root'))
